module.exports = __webpack_public_path__ + "producr-dried fresh-grass-20.jpg?231f33f80e17b84e7d290b47a4133a16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-20.jpg
// module id = 78
// module chunks = 0